import React from 'react';
import styled from 'styled-components';

interface AlignIconProps {
  left?: number;
  right?: number;
  align?: React.CSSProperties['alignItems'];
}

export const AlignIcon = styled.span<AlignIconProps>`
  display: inline-flex;
  align-items: ${({ align = 'center' }: AlignIconProps) => align};

  svg {
    ${({ left }) => left && `margin-left: calc(${left} * 1rem)`};
    ${({ right }) => right && `margin-right: calc(${right} * 1rem)`};
  }
`;
